import type { OptimisticObservable } from '@adornis/base/rxjs-extension.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import type { AdornisUser } from '@adornis/users/db/a-user.js';
import { createContext } from '@lit/context';

enum Context {
  CURRENT_USER = 'current-user',
  NAV_ELEMENT = 'nav-element',
}

export const currentUserContext = createContext<OptimisticObservable<Maybe<AdornisUser<any>>>, Context.CURRENT_USER>(
  Context.CURRENT_USER,
);

export const navElementContext = createContext<any, Context.NAV_ELEMENT>(Context.NAV_ELEMENT);
